const TAG_SEARCH_TERMS = ['레드', '화이트', '스파클링', '내추럴', '바로배송'];

function normalizeWhitespace(value) {
  return value.replace(/\s+/g, ' ').trim();
}

function stripTerm(value, term) {
  return value.split(term).join(' ');
}

function stripKnownTagTerms(value) {
  let strippedValue = value;

  [...TAG_SEARCH_TERMS, '전체'].forEach((term) => {
    strippedValue = stripTerm(strippedValue, term);
  });

  return normalizeWhitespace(strippedValue);
}

function parseTagAwareSearch(value, forcedTag = '') {
  const normalizedValue = normalizeWhitespace(value);
  const matchedTag =
    forcedTag ||
    TAG_SEARCH_TERMS.find((tag) => normalizedValue.includes(tag)) ||
    '';

  return {
    tag: matchedTag,
    query: stripKnownTagTerms(normalizedValue),
  };
}

class TownwineHomeSearchComponent extends HTMLElement {
  connectedCallback() {
    this.searchForm = this.querySelector('form');
    this.searchInput = this.querySelector('[data-home-search-input]');
    this.tagInput = this.querySelector('[data-home-search-tag-input]');
    this.filterButtons = Array.from(this.querySelectorAll('[data-home-search-tag]'));
    this.resultsScope = this.closest('.container') ?? this.parentElement;
    this.resultPanels = Array.from(this.resultsScope?.querySelectorAll('[data-home-results-panel]') ?? []);
    this.resultLink = this.resultsScope?.querySelector('[data-home-results-link]');
    this.resultLabel = this.resultsScope?.querySelector('[data-home-results-label]');
    this.resultCount = this.resultsScope?.querySelector('[data-home-results-count]');
    this.defaultResultLabel = this.resultLabel?.textContent?.trim() || '전체';
    this.defaultResultUrl = this.resultLink instanceof HTMLAnchorElement ? this.resultLink.getAttribute('href') ?? '' : '';

    this.addEventListener('click', this.#handleClick);
    this.searchForm?.addEventListener('submit', this.#handleSubmit);
    this.#showResults(this.tagInput instanceof HTMLInputElement ? this.tagInput.value : '');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.searchForm?.removeEventListener('submit', this.#handleSubmit);
  }

  #handleClick = (event) => {
    const button = event.target.closest('[data-home-search-tag]');

    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();

    const tag = button.dataset.homeSearchTag ?? '';
    const collectionUrl = button.dataset.collectionUrl;
    const searchValue = this.searchInput instanceof HTMLInputElement ? this.searchInput.value.trim() : '';

    this.#applyTagAwareSearch(tag);
    this.#setActiveButton(tag);

    if (searchValue !== '' && this.searchForm instanceof HTMLFormElement) {
      this.searchForm.requestSubmit();
      return;
    }

    if (this.#showResults(tag, collectionUrl)) {
      return;
    }

    if (collectionUrl) {
      window.location.href = collectionUrl;
    }
  };

  #handleSubmit = () => {
    const activeTag = this.tagInput instanceof HTMLInputElement ? this.tagInput.value : '';
    this.#applyTagAwareSearch(activeTag);
  };

  #applyTagAwareSearch(forcedTag = '') {
    if (!(this.searchInput instanceof HTMLInputElement) || !(this.tagInput instanceof HTMLInputElement)) return;

    const { tag, query } = parseTagAwareSearch(this.searchInput.value, forcedTag);

    this.searchInput.value = query;
    this.tagInput.value = tag;
  }

  #setActiveButton(activeTag) {
    this.filterButtons.forEach((button) => {
      const isActive = (button.dataset.homeSearchTag ?? '') === activeTag;
      button.classList.toggle('is-on', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  #showResults(activeTag, fallbackUrl = '') {
    if (!this.resultPanels.length) return false;

    const normalizedTag = activeTag ?? '';
    const fallbackPanel =
      this.resultPanels.find((panel) => (panel.dataset.homeResultsPanel ?? '') === '') ??
      this.resultPanels[0];
    const nextPanel =
      this.resultPanels.find((panel) => (panel.dataset.homeResultsPanel ?? '') === normalizedTag) ??
      fallbackPanel;

    this.resultPanels.forEach((panel) => {
      const isActive = panel === nextPanel;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.#syncResultsMeta(normalizedTag, nextPanel, fallbackUrl);

    return true;
  }

  #syncResultsMeta(activeTag, panel, fallbackUrl = '') {
    if (!(panel instanceof HTMLElement)) return;

    const nextLabel = activeTag || this.defaultResultLabel;
    const nextCount = panel.dataset.resultCount ?? '0';
    const nextUrl = panel.dataset.resultsUrl || fallbackUrl || this.defaultResultUrl;

    if (this.resultLabel instanceof HTMLElement) {
      this.resultLabel.textContent = nextLabel;
    }

    if (this.resultCount instanceof HTMLElement) {
      this.resultCount.textContent = nextCount;
    }

    if (this.resultLink instanceof HTMLAnchorElement && nextUrl) {
      this.resultLink.href = nextUrl;
    }
  }
}

if (!customElements.get('townwine-home-search')) {
  customElements.define('townwine-home-search', TownwineHomeSearchComponent);
}
